import React, { Component } from 'react'

export default class SectionMenu extends Component{
	close = () => {
		const { onClose } = this.props
		if (onClose) onClose()
	}

  render(){
  	const {children} = this.props
	  return(
	  	<div className="nav__content nav__content-section in">
	  		<div className="nav__content__overlay" onClick={this.close}/>
	    	<div className="nav__content__link-group in" style={{
	    		width: "1263px",
				transform: "translateY(-20px) translateX(1px)",
				justifyContent: "space-between",
				alignItems: "center",
	    	}}>
	    		{ children }
	    	</div>
	  	</div>
	  )
  }
}
